<template>
    <div class="footer-container">
        <div class="container-fluid">
            <FooterModal
                v-if="showFooterModal"
                @click="showFooterModal = $event"/>
            <div class="d-none d-md-block donation-details">
                <div class="row">
                    <div class="px-3 py-1 footer-first-section ">
                        <div>Dane do przelewu tradycyjnego</div>
                    </div>
                </div>
                <div class="row">
                    <div class="px-3 py-1 footer-second-section">
                        <div class="footer-text">
                            <div>Nr konta: </div>
                            <span>21 1750 0012 0000 0000 2060 1264</span>
                        </div>
                        <div class="footer-text">
                            <div>Odbiorca: </div>
                            <span>Stowarzyszenie WIOSNA <br> ul. Wielicka 20, 30-552 Kraków</span></div>
                        <div class="footer-text">
                            <div>Tytułem: </div>
                            <span>{{systemConst.PAYMENT_TITLE}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-xs-center justify-content-sm-center footer-third-section">
                <div class="col-xxs-12 col-xs-plus-4 col-xs-3 col-sm-3 col-md-2 col-xl-3 footer-text footer-logo-ct">
                    <img class="footer-logo pt-4" :src="require(`../../assets/images/${systemConst.FOOTER_LOGO_NAME}`)" title="Logo Systemu" alt="logo">
                </div>
                <div class="col-md-5 col-lg-auto footer-text font-weight-bold py-3 d-none d-md-block">
                    Masz problem z płatnością? Skontaktuj się z&nbsp;nami:
                    <br>
                    <img class="footer-mail-icon mr-2" :src="require(`../../assets/images/${systemConst.EMAIL_ICON_NAME}`)" title="email-icon" alt="email-icon">
                    <a :href="`mailto:${systemConst.SUMMARY_FOOTER_EMAIL}`" class="mb-2 email">{{systemConst.SUMMARY_FOOTER_EMAIL}}</a>
                    <br>
                    Kontakt dla firm:
                    <br>
                    <img class="footer-mail-icon mr-2" :src="require(`../../assets/images/${systemConst.EMAIL_ICON_NAME}`)" title="email-icon" alt="email-icon">
                    <a href="mailto:firma@wiosna.org.pl" class="email">firma@wiosna.org.pl</a>
                </div>
                <div class="col-xxs-10 col-xs-plus-8 col-xs-7 col-sm-7 col-md-5 footer-text font-weight-bold offset-2 offset-xs-0 offset-sm-0 offset-md-0  py-3">
                    Przydatne linki:
                    <a class="d-md-none underline" @click="scrollTo">Wróć do góry</a>
                    <a @click="showFooterModal = true">
                        <span class="d-none d-md-block underline">Dane do przelewu tradycyjnego (z&nbsp;Polski i&nbsp;zagranicy)</span>
                        <span class="d-md-none underline">Dane do wpłaty darowizny</span>
                    </a>
                    <a v-if="isNobleGift" :href="systemConst.SYSTEM_URL_DONATIONS_FROM_ABROAD" target="_blank">Wpłaty z zagranicy</a>
                    <a :href="pageUrl" target="_blank">Strona główna {{ systemConst.SYSTEM_GENITIVE }}</a>
                    <a :href="systemConst.SYSTEM_URL_PRIVACY_POLICY" target="_blank">Polityka Prywatności</a>
                    <a :href="systemConst.SYSTEM_URL_REGULATIONS" target="_blank">Regulamin</a>
                </div>
                <div class="d-md-none copyright">
                    <div class="footer-text font-weight-bold px-3" style="border-top: 1px solid white;">
                        &copy; {{ currentYear }} | Stowarzyszenie Wiosna
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import systemConst from '@SYSTEM_CONSTANTS'
import FooterModal from '../molecules/FooterModal'

export default {
    name: 'Footer',
    data () {
        return {
            systemConst,
            pageUrl: process.env.VUE_APP_PAGE_URL,
            isNobleGift: process.env.VUE_APP_SYSTEM === 'szp',
            showFooterModal: false,
            currentYear: (new Date()).getFullYear()
        }
    },
    methods: {
        scrollTo () {
            window.scrollTo(0, 0)
        }
    },
    components: {
        FooterModal
    }
}
</script>
